/**
 * Canonical OPAL FacetedSearchDrawer / column-settings label map, wired to the
 * shared `columnSettings.*` + `table.reorder*` i18n keys.
 *
 * Every consumer of OPAL's `useColumnSettings` MUST build its labels from here:
 * OPAL falls back to hard-coded English defaults for any label the consumer
 * omits, so a hand-copied partial map silently ships untranslated chrome
 * ("Order", "Search a column", "9 of 9 selected", "Pinned"…) — see R29.
 *
 * Pass `overrides` for feature-specific copy (e.g. a campaign-specific drawer
 * title). Anything not overridden uses the shared translation.
 */
export function buildColumnSettingsLabels(t, overrides = {}) {
    return {
        title: t("columnSettings.title"),
        subtitle: (visible, total) => t("columnSettings.subtitleSelected", { visible, total }),
        searchPlaceholder: t("columnSettings.searchPlaceholder"),
        searchClearLabel: t("common.clearSearch"),
        visibleTab: t("columnSettings.tabVisible"),
        orderTab: t("columnSettings.tabOrder"),
        defaultColumnHeader: t("columnSettings.defaultFixedColumnHeader"),
        pinnedBadge: t("columnSettings.pinnedBadge"),
        resetLabel: t("columnSettings.resetButton"),
        cancelLabel: t("columnSettings.cancelButton"),
        saveLabel: t("columnSettings.saveButton"),
        closeAriaLabel: t("columnSettings.closeAriaLabel"),
        emptySearchText: t("columnSettings.emptySearchText"),
        emptyOrderText: t("columnSettings.emptyOrderText"),
        orderSearchHint: t("columnSettings.orderSearchHint"),
        pinTooltip: t("columnSettings.pinTooltip"),
        pinAriaLabelPinned: t("columnSettings.pinAriaLabelPinned"),
        pinAriaLabelUnpinned: t("columnSettings.pinAriaLabelUnpinned"),
        pinLimitTooltip: t("columnSettings.pinLimitTooltip"),
        reorderMoved: (label, position, total) => t("table.reorderMoved", { label, position, total }),
        reorderPickedUp: (label) => t("table.reorderPickedUp", { label }),
        reorderCancelled: (label) => t("table.reorderCancelled", { label }),
        ...overrides,
    };
}
